import {useContext} from '@wordpress/element';
import {CreditCardContext} from '../contexts';

export const useCreditCardContext = () => {
    return useContext(CreditCardContext);
}